import i18next from "i18next"
import { AsyncState, Unit } from "widgets-for-react"
import { Updater } from "widgets-for-react";
import { buildValidator, isValidatorPassed, Validator, validatorBuilders, ValidatorResult, validatorResultBuilders } from "../../../Shared/Frontend/validators/validator";
import { submitContactUs } from "./contactUs.api"

export type ContactUsInput = {
  subject: string
  body: string
  name: string
  email: string
  phoneNumber: string
}

export type ContactUsState = {
  input: Partial<ContactUsInput>
  submission?: AsyncState<Unit>,
  validator:Validator<ContactUsState["input"], ContactUsState["input"]>,
  validatorResult:ValidatorResult
  isValid():boolean,
}

const contactUsValidator = buildValidator<ContactUsState["input"]>({
  name:[b => b.notEmpty(), validatorBuilders.string("name", () => i18next.t<string>(`contact:nameError`))],
  body:[b => b.notEmpty(), validatorBuilders.string("body", () => i18next.t<string>(`contact:bodyError`))],
  subject:[b => b.notEmpty(), validatorBuilders.string("subject", () => i18next.t<string>(`contact:subjectError`))],
  email:[b => b.isEmail(), validatorBuilders.string("email", () => i18next.t<string>(`contact:emailError`))],
  phoneNumber:[b => b.isPhone(), validatorBuilders.string("phoneNumber", () => i18next.t<string>(`contact:phoneNumberError`))],
})

export const initialContactUsState: ContactUsState = ({ 
  input: {},
  validator:contactUsValidator.setValueToValidate({}, {}),
  validatorResult:validatorResultBuilders.validating(""),
  isValid:function(this:ContactUsState) { return isValidatorPassed(this.validatorResult) }
})

export const contactUsUpdaters = {
  input:(u:Updater<ContactUsState["input"]>) : Updater<ContactUsState> =>
    s => {
      const newInput = u(s.input)
      return ({...s, input:newInput, validator:s.validator.setValueToValidate(newInput, newInput)})
    },
  fields:{
    name: (newValue: string): Updater<ContactUsState> => contactUsUpdaters.input(_ => ({..._, name:newValue})),
    email: (newValue: string): Updater<ContactUsState> => contactUsUpdaters.input(_ => ({..._, email:newValue})),
    phoneNumber: (newValue: string): Updater<ContactUsState> => contactUsUpdaters.input(_ => ({..._, phoneNumber:newValue})),
    subject: (newValue: string): Updater<ContactUsState> => contactUsUpdaters.input(_ => ({..._, subject:newValue})),
    body: (newValue: string): Updater<ContactUsState> => contactUsUpdaters.input(_ => ({..._, body:newValue})),
  },
  submission: (newValue: Updater<AsyncState<Unit>>): Updater<ContactUsState> =>
    contactUs => ({
      ...contactUs,
      submission: contactUs.submission ? newValue(contactUs.submission) : contactUs.submission
    }),
  validation:(u:Updater<ContactUsState["validator"]>) : Updater<ContactUsState> =>
    s => {
      const newValidator = u(s.validator)
      return ({...s, validator:newValidator, validatorResult:newValidator.evaluateResult() })
    },    
  submit: (): Updater<ContactUsState> =>
    contactUs => ({
      ...contactUs,
      submission: submitContactUs(contactUs)
    }),
}
